import { useEffect } from "react";

declare global {
  interface ExtendedWindow extends Window {
    _uxa?: UxaProps[];
  }
}
type UxaProps = (string | ContentsquareTransactionProps)[];

type ContentsquareTransactionProps = {
  id?: string;
  revenue: number | null;
  currency: string;
  isReady?: boolean;
};

const useContentsquareConfirmationOption = (
  props: ContentsquareTransactionProps
) => {
  const { id, revenue, currency, isReady } = props;

  useEffect(() => {
    const triggerContentsquareTransaction = () => {
      const extendedWindow = window as ExtendedWindow;
      extendedWindow._uxa = extendedWindow._uxa ?? [];

      // Create transaction data
      extendedWindow._uxa.push([
        "ec:transaction:create",
        {
          id: id,
          revenue: revenue,
          currency: currency,
        },
      ]);

      // Send the transaction to Contentsquare
      extendedWindow._uxa.push(["ec:transaction:send"]);
    };

    if (isReady) {
      triggerContentsquareTransaction();
    }
  }, [isReady, id, revenue, currency]);
};

export default useContentsquareConfirmationOption;
